/**
 * @param {jQuery} $ jQuery object.
 * @param {Astoundify} Astoundify Astoundify object.
 */
(function( $, Astoundify ) {

	/**
	 * Comments
	 *
	 * @since 1.0.0
	 * @type {object}
	 */
	var self = Astoundify.Comments || {};

	/**
	 * Hide all children comments by default.
	 *
	 * @since 1.0.0
	 */
	self.hideChildren = function() {
		$( '.comment' ).each(function() {
			var $children = $(this).find( '.children' );
			var $viewChildren = $(this).find( '.comment-more-replies' );

			if ( $children.length > 0 ) {
				$children.hide();
			} else {
				$viewChildren.hide();
			}
		});
	};

	/**
	 * Toggle children.
	 *
	 * @since 1.0.0
	 */
	self.toggleChildren = function() {
		$( '.comment-more-replies' ).on( 'click', function(e) {
			e.preventDefault();

			$(this)
				.toggleClass( 'comment-more-replies--is-open' )
				.parents( '.comment' )
				.find( '.children' )
				.toggle();
		});
	};

	/**
	 * Bind to the DOM
	 *
	 * @since 1.0.0
	 */
	$(document).ready(function() {

		/**
		 * @see http://www.jacklmoore.com/autosize/
		 */
		autosize( $( '.respond__new' ) );

		/**
		 * Toggle comments
		 */
		self.hideChildren();
		self.toggleChildren();

	});

})( jQuery, Astoundify );
